<script setup lang="ts">
import { computed } from 'vue';
import Multiselect from 'vue-multiselect';
import { Button } from '@/components/ui/button';

const props = defineProps<{
    movementCategories: any[];
    availableYears: number[];
}>();

const selectedCategories = defineModel<any[]>('selectedCategories', { default: () => [] });
const selectedYear = defineModel<number | null>('selectedYear', { default: null });
</script>

<template>
    <div class="bg-muted/30 border border-border rounded-xl p-6 flex flex-col xl:flex-row xl:items-center gap-6">
        
        <!-- Category Filter -->
        <div v-if="movementCategories.length > 0" class="flex-1 flex flex-col md:flex-row md:items-center gap-6">
            <div class="space-y-1 min-w-[180px]">
                <h4 class="text-sm font-bold text-foreground uppercase tracking-wider">Catégories</h4>
                <p class="text-xs text-muted-foreground">Filtrer par type d'opération.</p>
            </div>
            <div class="flex-1 flex items-center gap-3">
                <div class="flex-1 max-w-md">
                    <Multiselect
                        v-model="selectedCategories"
                        :options="movementCategories"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Toutes les catégories..."
                        label="name"
                        track-by="id"
                        class="custom-multiselect" 
                    />
                </div>
                <Button v-if="selectedCategories.length > 0" variant="ghost" size="sm" 
                         class="text-red-500 hover:text-red-700 hover:bg-red-500/10" @click="selectedCategories = []">
                    Effacer
                </Button>
            </div>
        </div>

        <div v-if="movementCategories.length > 0" class="hidden xl:block w-px h-12 bg-border mx-2"></div>

        <!-- Year Filter -->
        <div class="flex flex-col md:flex-row md:items-center gap-6">
            <div class="space-y-1 min-w-[150px]">
                <h4 class="text-sm font-bold text-foreground uppercase tracking-wider">Année</h4>
                <p class="text-xs text-muted-foreground">Cibler une période.</p>
            </div>
            <div class="flex items-center gap-3">
                <select 
                    v-model="selectedYear"
                    class="flex h-10 w-[180px] rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                >
                    <option :value="null">Toutes les années</option>
                    <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                </select>
                <Button v-if="selectedYear" variant="ghost" size="sm" 
                         class="text-red-500 hover:text-red-700 hover:bg-red-500/10" @click="selectedYear = null">
                    Effacer
                </Button>
            </div>
        </div>
    </div>
</template>
